import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Alert,
} from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useGetPendingOrdersByAreaMutation } from "../slices/orderApiSlice";
import { FaEye } from "react-icons/fa";

const PendingOrdersByArea = () => {
  const navigate = useNavigate();
  const params = useParams();
  const area = params.area; // e.g. route like "/orders/pending/:area"

  const [getOrders, { data: orders = [], isLoading, isError, error }] =
    useGetPendingOrdersByAreaMutation();

  useEffect(() => {
    if (area) {
      // call the API with area
      getOrders(area);
    }
  }, [area, getOrders]);

  const handleViewDetails = (orderId) => {
    navigate(`/vendor/orders/${orderId}`); // or whatever your route is
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <Container className="py-4">
      <Row className="mb-3">
        <Col>
          <Button variant="link" onClick={handleBack}>
            ← Back to Home
          </Button>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h3 className="text-primary">Pending Orders — {area}</h3>
        </Col>
      </Row>

      {isLoading ? (
        <Row className="justify-content-center my-5">
          <Spinner animation="border" variant="primary" />
        </Row>
      ) : isError ? (
        <Alert variant="danger">
          Error: {error?.data?.message || error.error}
        </Alert>
      ) : orders.length === 0 ? (
        <Alert variant="info">
          No pending orders found for <strong>{area}</strong>.
        </Alert>
      ) : (
        <Row xs={1} sm={1} md={2} lg={2} className="g-3">
          {orders.map((order) => (
            <Col key={order._id}>
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <Card.Title>
                    {order.customerId?.name} (
                    {order.customerId?.email || "No Email"})
                  </Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    Status: {order.status}
                  </Card.Subtitle>

                  <Card.Text>
                    <strong>Total Amount:</strong> ₹
                    {order.totalAmount.toFixed(2)}
                  </Card.Text>

                  <Card.Text>
                    <strong>Shipping Address:</strong>
                    <br />
                    {order.shippingAddress.address}, {order.shippingAddress.city}{" "}
                    {order.shippingAddress.pincode}
                    <br />
                    <strong>Area:</strong> {order.shippingAddress.area}
                    <br />
                    <strong>Phone:</strong> {order.shippingAddress.phoneNumber}
                  </Card.Text>

                  <hr />

                  <div>
                    <strong>Products:</strong>
                    {order.products.map((product, idx) => (
                      <div key={product.productId?._id || idx} className="mb-1">
                        {product.productId?.name || "Product"} — Qty:{" "}
                        {product.quantity}, Price: ₹{product.price.toFixed(2)}
                      </div>
                    ))}
                  </div>
                </Card.Body>
                <Card.Footer className="bg-white border-top-0">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => handleViewDetails(order._id)}
                  >
                    <FaEye className="me-1" />
                    View Details
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default PendingOrdersByArea;
